import React from 'react'
import LandingHeader from "./LandingHeader"
import FooterOther from './FooterOther'

const About = () => {

    return (
        <div>
            <LandingHeader />
            <div className='max-w-[1300px] mx-auto mt-[50px] mb-[300px]'>

                <h2 className='font-semibold text-[30px]'>About Us</h2>
                <div>
                    <p>
                        At Orden Technical Services Pvt. Ltd., we are a high-powered team of seasoned educators and
                        technology experts united by a common goal – to redefine learning. Drawing on deep insights from
                        emerging trends in education, we blend pedagogical excellence with cutting-edge technology to create
                        innovative, engaging, and effective learning experiences. Our flagship platform, LexiLearn.in, is a
                        testament to this synergy – designed to support schools and colleges in enhancing literacy and
                        comprehension through data-driven tools and adaptive content.
                    </p>

                    <p>
                        With a progressive vision to transform the education landscape, we are committed to building tech-
                        driven solutions that empower learners, educators, and institutions alike. Our approach is rooted in
                        research, collaboration, and a future-forward mindset – ensuring that learning remains relevant,
                        inclusive, and impactful in the digital age.
                    </p>
                </div>
            </div>
            <FooterOther />
        </div>
    )
}

export default About